import { Link } from "react-router-dom";
import { FaPlane, FaShip, FaMoon, FaCircle } from "react-icons/fa";
import type { Plan } from "../types/plans";
import { formatPrice } from "../hooks/usePlans";
import { useLocale } from "../i18n/LocaleContext";

const TRANSPORT_ICONS: Record<string, React.ReactNode> = {
  vuelo: <FaPlane />,
  crucero: <FaShip />,
  autobus: <FaShip />,
  terrestre: <FaShip />,
  na: <FaPlane />,
}

interface PlanCardProps {
  plan: Plan
  destinationName?: string
}

const PlanCard = ({ plan, destinationName }: PlanCardProps) => {
  const { locale, t } = useLocale();
  const header = destinationName ?? plan.category ?? "Mega Travel"
  return (
    <article className="plan-card">
      <Link to={`/planes/${plan.id}`} className="plan-card-link">
        <div className={`plan-card-media ${plan.image ? "" : "plan-card-media--placeholder"}`}>
          {plan.image ? (
            <img src={plan.image} alt={plan.title} loading="lazy" />
          ) : (
            <span className="plan-card-emoji" aria-hidden="true">🌴</span>
          )}
          <span className={`plan-availability plan-availability--${plan.availability}`}>
            <FaCircle aria-hidden="true" />
            {t.availability[plan.availability]}
          </span>
          {plan.planType === "bloqueo" && (
            <span className="plan-ribbon">Bloqueo</span>
          )}
        </div>

        <div className="plan-card-body">
          <p className="plan-destination">{header}</p>
          <h3 className="plan-title">{plan.title}</h3>

          <div className="plan-meta">
            {plan.days != null && (
              <span className="plan-chip">
                <FaMoon aria-hidden="true" /> {t.plan.days(plan.days)}{plan.nights != null ? ` / ${t.plan.nights(plan.nights)}` : ""}
              </span>
            )}
            <span className="plan-chip">
              {TRANSPORT_ICONS[plan.transport]} {t.transport[plan.transport] ?? t.transport.na}
            </span>
            {plan.countries.length > 0 && (
              <span className="plan-chip plan-chip--soft">{plan.countries.slice(0, 3).join(", ")}{plan.countries.length > 3 ? ` +${plan.countries.length - 3}` : ""}</span>
            )}
          </div>

          <p className="plan-price">
            <strong>{formatPrice(plan.price, locale)}</strong>
            {plan.price.amount != null && (
              <>
                <span> {plan.price.currency}</span>
                {plan.price.taxes != null && (
                  <span className="plan-price-note"> + {formatPrice({ ...plan.price, amount: plan.price.taxes }, locale).split(" ")[0]} {plan.price.currency} {t.plan.taxesShort}</span>
                )}
              </>
            )}
          </p>
        </div>
      </Link>
    </article>
  );
};

export default PlanCard;
